module.exports = __webpack_public_path__ + "img/tab-system.6801d446.png";